import React from "react";
import { getConnectionStatus } from "../utils/SocialConnectionsUtils";
import { NotLoggedInError, NotAuthorizedError, DisclaimerNotEndorsedError } from "../utils/error";
import Disclaimer from "./Disclaimer";
var ChartError = function(param) {
    var intl = param.intl, errors = param.errors, engagementServerEnabled = param.engagementServerEnabled, updateErrors = param.updateErrors, acceptDisclaimer = param.acceptDisclaimer, disclaimerText = param.disclaimerText;
    var getErrorType = function getErrorType(currentError) {
        if (!currentError) return "unknown";
        switch(currentError.constructor){
            case DisclaimerNotEndorsedError:
                return "disclaimer";
            case NotLoggedInError:
                return "notLoggedIn";
            case NotAuthorizedError:
                return "notAuthorized";
            default:
                return "unknown";
        }
    };
    var getErrorContent = function getErrorContent(currentError) {
        if (!currentError) return /*#__PURE__*/ React.createElement("div", null);
        switch(currentError.constructor){
            case DisclaimerNotEndorsedError:
                return /*#__PURE__*/ React.createElement(Disclaimer, {
                    intl: intl,
                    disclaimerText: disclaimerText || "",
                    acceptDisclaimer: acceptDisclaimer
                });
            case NotLoggedInError:
                return /*#__PURE__*/ React.createElement("div", {
                    className: "chart-error__content chart-error__content--not-logged-in"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "chart-not-logged-in__header"
                }, /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
                    id: "charterror.notLoggedIn.header",
                    defaultMessage: "You are not logged in."
                }))), /*#__PURE__*/ React.createElement("div", {
                    className: "chart-not-logged-in__body"
                }, /*#__PURE__*/ React.createElement("p", null, engagementServerEnabled ? intl.formatMessage({
                    id: "charterror.notLoggedIn.message",
                    defaultMessage: "You are currently not logged into our Community Server, this may take some time."
                }) : intl.formatMessage({
                    id: "charterror.engagementServerDisabled.message",
                    defaultMessage: "The engagement server needed to show this content has been disabled, most likely due to GDPR reasons. If you believe this to be an error, please contact your supervisor."
                }))));
            case NotAuthorizedError:
                return /*#__PURE__*/ React.createElement("div", {
                    className: "chart-error__content chart-error__content--not-authorized"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "chart-not-logged-in__header"
                }, intl.formatMessage({
                    id: "charterror.notAuthorized.header",
                    defaultMessage: "You are not authorized to see this content"
                })), /*#__PURE__*/ React.createElement("div", {
                    className: "chart-not-logged-in__body"
                }, intl.formatMessage({
                    id: "charterror.notAuthorized.message",
                    defaultMessage: "The server denied your request to see this content. Please contact your supervisor."
                })));
            default:
                return /*#__PURE__*/ React.createElement("div", {
                    className: "chart-error__content"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "chart-error__header"
                }, intl.formatMessage({
                    id: "charterror.error.header",
                    defaultMessage: "Error"
                })), /*#__PURE__*/ React.createElement("p", {
                    className: "chart-error__body"
                }, isError ? intl.formatMessage({
                    id: "social.activities.errorHeader",
                    defaultMessage: "An error with status {status} occured"
                }, {
                    status: status
                }) : currentError.message || currentError), /*#__PURE__*/ React.createElement("button", {
                    onClick: function() {
                        updateErrors();
                    }
                }, intl.formatMessage({
                    id: "charterror.error.btn",
                    defaultMessage: "Continue"
                })));
        }
    };
    var disclaimerError = errors.find(function(e) {
        return !!e && e.constructor === DisclaimerNotEndorsedError;
    });
    var currentError = disclaimerError || errors[0];
    var type = getErrorType(currentError);
    var content = getErrorContent(currentError);
    var status = (currentError === null || currentError === void 0 ? void 0 : currentError.status) || getConnectionStatus("tweet");
    var isError = status > 399;
    if (currentError && currentError.constructor !== DisclaimerNotEndorsedError && currentError.constructor !== NotLoggedInError && currentError.constructor !== NotAuthorizedError) {
        console.error("Unknown error", currentError);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "chart-error chart-error--".concat(type)
    }, content);
};
export default ChartError;
